export default [
  {
    value: 'Türkiye',
    text: 'Türkiye',
  },
  {
    value: 'Almanya',
    text: 'Almanya',
  },
  {
    value: 'Fransa',
    text: 'Fransa',
  },
  {
    value: 'Amerika',
    text: 'Amerika',
  },
  {
    value: 'Suudi Arabistan',
    text: 'Suudi Arabistan',
  },
  {
    value: 'Belçika',
    text: 'Belçika',
  },
  {
    value: 'Kanada',
    text: 'Kanada',
  },
  {
    value: 'Avusturya',
    text: 'Avusturya',
  },
  {
    value: 'Avusturalya',
    text: 'Avusturalya',
  },
  {
    value: 'Irak',
    text: 'Irak',
  },
  {
    value: 'İran',
    text: 'İran',
  },
  {
    value: 'Bulgaristan',
    text: 'Bulgaristan',
  },
];

// Almanya Fransa Amerika Filistin Suudi Arabistan Belçika Kanada Avusturya Avusturalya Irak İran Bulgaristan
